export default __webpack_public_path__ + "assets/e4f42ec7ba6e5f6ebe3d243833b5bb22.jpg";